<template>
  <span
    class="v2-badge"
    :class="`v2-badge--${variant}`"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'V2Badge',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'primary', 'secondary', 'success', 'warning', 'destructive', 'outline'].includes(v),
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--v2-space-0-5) var(--v2-space-2);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  border-radius: var(--v2-radius-full);
  white-space: nowrap;

  &--default    { background: var(--v2-muted); color: var(--v2-muted-foreground); }
  &--primary    { background: var(--v2-primary); color: var(--v2-primary-foreground); }
  &--secondary  { background: var(--v2-secondary); color: var(--v2-secondary-foreground); }
  &--success    { background: var(--v2-success); color: #fff; }
  &--warning    { background: var(--v2-warning); color: #fff; }
  &--destructive { background: var(--v2-destructive); color: #fff; }
  &--outline    { background: transparent; border: 1px solid var(--v2-border); color: var(--v2-foreground); }
}
</style>
